module.exports = __webpack_public_path__ + "files/018851f1ded8691d70d6952126dda862.svg";